/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-46de7b2e.js';
import { i as isEmpty_1 } from '../_chunks/dep-64a9d67c.js';
import { i as isFunction_1 } from '../_chunks/dep-f10515e8.js';
import { i as isString_1 } from '../_chunks/dep-6c5254c6.js';
import React from 'react';
import '../_chunks/dep-c3f1141e.js';
import '../_chunks/dep-23d0a0bb.js';
import '../_chunks/dep-934eda0c.js';
import '../_chunks/dep-4941ebe7.js';
import '../_chunks/dep-e9b62d1f.js';
import '../_chunks/dep-7dce2c26.js';
import '../_chunks/dep-12510d64.js';
import '../_chunks/dep-dcb5aa2a.js';
import '../_chunks/dep-6b568d83.js';
import '../_chunks/dep-7b52f080.js';
import '../_chunks/dep-88cd50bf.js';
import '../_chunks/dep-77e34309.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var getDefaultValue = function getDefaultValue(value, defaultValue) {
  if (isEmpty_1(value)) {
    return Array.isArray(defaultValue) ? defaultValue : [defaultValue, defaultValue];
  }
  if (Array.isArray(value)) return value;
  return [defaultValue, defaultValue];
};
var getJSX = function getJSX(value) {
  if (isString_1(value)) return value;
  if (isFunction_1(value)) return value();
  if ( /*#__PURE__*/React.isValidElement(value)) return value;
  return value;
};
var getLeafNodes = function getLeafNodes(nodes) {
  var resData = [];
  var map = function map(nodes2) {
    nodes2.forEach(function (child) {
      if (child.children && child.children.length > 0) {
        return map(child.children);
      }
      resData.push(child);
    });
  };
  map(nodes);
  return resData;
};
var filterCheckedTreeNodes = function filterCheckedTreeNodes(nodes, checkeds) {
  return nodes.filter(function (item) {
    return !checkeds.includes(item.value);
  }).map(function (item) {
    var newItem = _objectSpread({}, item);
    if (item.children && item.children.length > 0) {
      newItem.children = filterCheckedTreeNodes(item.children, checkeds);
    }
    return newItem;
  }).filter(function (item) {
    return item.children && item.children.length !== 0 || !item.children;
  });
};
var getTargetNodes = function getTargetNodes(sourceNodes, data) {
  var source = getLeafNodes(sourceNodes).map(function (item) {
    return item.value;
  });
  return filterCheckedTreeNodes(data, source);
};

export { filterCheckedTreeNodes, getDefaultValue, getJSX, getLeafNodes, getTargetNodes };
//# sourceMappingURL=utils.js.map
